import React, { useState, useEffect } from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';
import { ExclamationTriangleFill, CheckLg } from 'react-bootstrap-icons';

const GROUPS = ['Staff Roster & Users', 'Mobile App', 'Police & Fire' ];

/**
 * GroupsModal
 *
 * Props
 * ───────────────────────────────────────────────
 * @param {boolean}  show
 * @param {function} onHide
 * @param {function} onSave   – called with array of selected groups
 * @param {string[]} initial  – optional pre-selected groups
 */
const GroupsModal = ({ show, onHide, onSave, initial = ['Staff Roster & Users'] }) => {
  const [selected, setSelected] = useState(initial);

  /* reset each time the modal opens */
  useEffect(() => {
    if (show) setSelected(initial);
  }, [show, initial]);

  const toggle = (g) =>
    setSelected((prev) =>
      prev.includes(g) ? prev.filter((x) => x !== g) : [...prev, g]
    );

  const handleSave = () => {
    onSave?.(selected.length ? selected : ['Staff Roster & Users']);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Header className="py-2 px-3" closeButton>
        <Button
          variant="outline-primary"
          className="w-100 d-flex align-items-center justify-content-center gap-2"
          disabled
        >
          <ExclamationTriangleFill size={18} />
          Select Groups
        </Button>
      </Modal.Header>

      <Modal.Body className="pt-2 pb-3">
        <ListGroup>
          {GROUPS.map((g) => {
            const active = selected.includes(g);
            return (
              <ListGroup.Item
                key={g}
                action
                active={active}
                className="d-flex justify-content-between align-items-center"
                onClick={() => toggle(g)}
              >
                <span>{g}</span>
                {active && <CheckLg color="white" />}
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      </Modal.Body>

      <Modal.Footer className="py-2">
        <Button
          variant="primary"
          className="w-100 py-1"
          onClick={handleSave}
        >
          Use Selection
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GroupsModal;


